import { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';
import nl from 'date-fns/locale/nl';
import ru from 'date-fns/locale/ru';
import it from 'date-fns/locale/it';
import pt from 'date-fns/locale/pt';
import cs from 'date-fns/locale/cs';
import sv from 'date-fns/locale/sv';

// Registra d'un cop tots els idiomes de la web per a react-datepicker.
// Sense el registre, el calendari cau a l'anglès per defecte (el
// `locale={lang}` del DatePicker només troba els idiomes registrats).
// Idempotent: es pot cridar a cada render.
const LOCALES = { es, ca, fr, de, nl, ru, it, pt, cs, sv };

let registrats = false;

export function registrarLocalesCalendario() {
    if (registrats) return;
    Object.entries(LOCALES).forEach(([codi, locale]) => registerLocale(codi, locale));
    registrats = true;
}
